module.exports = __webpack_public_path__ + "media/packs/images/status-fetching-2be7058093f3b09c1ef6bc7625860250.svg";